export default class CustomerService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  updateLedgerAccountNumber(ledgerAccountId, accountNumber) {
    return this.axiosIns.patch(
      `/api/v1/ledger-accounts/${ledgerAccountId}/update-account-number/${accountNumber}`
    );
  }

  getCustomerPrices(id) {
    return this.axiosIns.get(`/api/v1/customer-region-prices/${id}`);
  }

  getCustomerPriceDetail(customer_id, price_detail_id) {
    return this.axiosIns.get(`/api/v1/customer-region-prices/${customer_id}/${price_detail_id}`);
  }

  createCustomerPrices(id, args) {
    return this.axiosIns.post(`/api/v1/customer-region-prices/${id}`, args);
  }

  editCustomerRegionPrice(customer_id, price_detail_id, args) {
    return this.axiosIns.put(
      `/api/v1/customer-region-prices/${customer_id}/${price_detail_id}`,
      args
    );
  }

  deleteCustomerPrices(id) {
    return this.axiosIns.delete(`/api/v1/customer-region-prices/${id}`);
  }

  createUser(args) {
    return this.axiosIns.post(`${this.serviceConfig.customer}/create-user`, args);
  }

  getAccountCompanyInfos() {
    return this.axiosIns.get(`${this.serviceConfig.customer}/my-info`);
  }

  updateAccountCompanyInfos(args) {
    return this.axiosIns.post(`${this.serviceConfig.customer}/my-info`, args);
  }

  deleteCustomerDocument(id) {
    return this.axiosIns.delete(`${this.serviceConfig.customersDocuments}/${id}`);
  }

  downloadCustomerDocument(id) {
    return this.axiosIns.get(`${this.serviceConfig.customersDocuments}/${id}/download`, {
      responseType: 'blob'
    });
  }

  deleteCustomerParameter(id) {
    return this.axiosIns.delete(`${this.serviceConfig.customersParameters}/${id}`);
  }

  getAllDocuments(args) {
    return this.axiosIns.get(`${this.serviceConfig.customersDocuments}`, args);
  }

  getDocument(id) {
    return this.axiosIns.get(`${this.serviceConfig.customersDocuments}/${id}`);
  }

  getAllCustomerDocuments(args) {
    return this.axiosIns.get(`${this.serviceConfig.customersDocuments}`, { params: args });
  }

  editCustomerDocument(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.customersDocuments}/${id}`, args);
  }

  uploadCustomerDocuments(args) {
    return this.axiosIns.post(`${this.serviceConfig.customersDocuments}`, args);
  }

  uploadCustomerDocumentsById(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.customers}/${id}/documents`, args);
  }

  getAllParameters(args) {
    return this.axiosIns.get(`${this.serviceConfig.customersParameters}`, args);
  }

  getParameter(id) {
    return this.axiosIns.get(`${this.serviceConfig.customersParameters}/${id}`);
  }

  getAllCustomerParameters(args) {
    return this.axiosIns.get(`${this.serviceConfig.customersParameters}`, { params: args });
  }

  createCustomerParameter(args) {
    return this.axiosIns.post(`${this.serviceConfig.customersParameters}`, args);
  }

  editCustomerParameter(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.customersParameters}/${id}`, args);
  }

  createCustomerUser(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.customers}/${id}/users`, args);
  }

  getAllCustomers(args) {
    return this.axiosIns.get(this.serviceConfig.customers, { params: args });
  }

  getCustomer(id) {
    return this.axiosIns.get(`${this.serviceConfig.customers}/${id}`);
  }

  createCustomer(args) {
    return this.axiosIns.post(`${this.serviceConfig.customers}`, args);
  }

  editCustomer(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.customers}/${id}`, args);
  }

  deleteCustomer(id) {
    return this.axiosIns.delete(`${this.serviceConfig.customers}/${id}`);
  }

  getCustomerPricingByPackageType({ providerId, packageType, packageValue, customerId }) {
    return this.axiosIns.get(
      `${'/api/v1/customer-region-prices-table'}/${customerId}/${providerId}/${packageType}/${
        packageValue || 'Butün Paket Türleri'
      }`
    );
  }

  previewCustomerPricing({ file, providerId, packageType, packageValue, customerId }) {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('providerId', providerId);
    formData.append('packageType', packageType);
    formData.append('packageTypeValue', packageValue);
    return this.axiosIns.post(`${'/api/v1/customer-region-prices'}/import/${customerId}`, formData);
  }

  createPricing(importId) {
    return this.axiosIns.post(`${`/api/v1/customer-region-prices`}/import/${importId}/confirm`);
  }

  getCustomerAssigneProvider(id) {
    return this.axiosIns.get(`${this.serviceConfig.customers}/${id}/update-providers`);
  }

  updateCustomerAssigneProvider(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.customers}/${id}/update-providers`, args);
  }

  getAllCustomerReturnFeesForSale() {
    return this.axiosIns.get(`/api/v1/customers/return-fees/all`);
  }

  getCustomerReturnFeeForSale(customerId, providerId) {
    return this.axiosIns.get(`/api/v1/customers/${customerId}/return-fees/${providerId}`);
  }

  createCustomerReturnFeeForSale(customerId, providerId, args) {
    return this.axiosIns.post(`/api/v1/customers/${customerId}/return-fees/${providerId}`, args);
  }

  editCustomerReturnFeeForSale(customerId, providerId, args) {
    return this.axiosIns.put(`/api/v1/customers/${customerId}/return-fees/${providerId}`, args);
  }

  getCustomerRestrictedDestinations(args) {
    return this.axiosIns.get(`/api/v1/country-blacklists`, {
      params: args
    });
  }

  createCustomerRestrictedDestination(args) {
    return this.axiosIns.post(`/api/v1/country-blacklists`, args);
  }

  deleteCustomerRestrictedDestination(restrictionId) {
    return this.axiosIns.delete(`/api/v1/country-blacklists/${restrictionId}`);
  }
}
